import { Question } from '../../types';

interface UseQuestionTogglesProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function useQuestionToggles({ question, onEdit }: UseQuestionTogglesProps) {
  const toggleRequired = () => {
    onEdit(question.id, { isRequired: !question.isRequired });
  };

  const toggleShowInReport = () => {
    onEdit(question.id, { showInSimplifiedReport: !question.showInSimplifiedReport });
  };

  const toggleHint = () => {
    if (question.hasHint) {
      onEdit(question.id, { hasHint: false, hintText: '' });
    } else {
      onEdit(question.id, { hasHint: true, hintText: '' });
    }
  };

  return {
    toggleRequired,
    toggleShowInReport,
    toggleHint,
  };
}
